import { render } from "./TicketAnalytics.vue?vue&type=template&id=009fed33&scoped=true"
import script from "./TicketAnalytics.vue?vue&type=script&lang=js"
export * from "./TicketAnalytics.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=009fed33&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009fed33"]])

export default __exports__